<script>
export default {
  name: 'KycImageThumb',
  props: {
    hash: { type: String, required: true },
    label: { type: String, required: true },
  },
  data() {
    return { url: null, loading: true };
  },
  mounted() {
    this.$bgService.get('/client-kyc/images/' + this.hash)
        .then(r => { this.url = r.data; })
        .catch(() => { this.url = null; })
        .finally(() => { this.loading = false; });
  },
  methods: {
    openLarge() {
      if (this.url) window.open(this.url, '_blank');
    },
  },
  render(h) {
    let inner;
    if (this.loading) {
      inner = h('div', { class: 'kyc-thumb__loading' }, [
        h('b-spinner', { props: { small: true } }),
      ]);
    } else if (this.url) {
      inner = h('img', { attrs: { src: this.url, alt: this.label } });
    } else {
      inner = h('div', { class: 'kyc-thumb__err' }, [
        h('font-awesome-icon', { props: { icon: 'image' } }),
      ]);
    }
    return h('div', {
      class: 'kyc-thumb',
      on: { click: this.openLarge },
    }, [
      inner,
      h('div', { class: 'kyc-thumb__lbl' }, this.label),
    ]);
  },
};
</script>

<style scoped>
.kyc-thumb {
  width: 120px; height: 100px;
  border: 1px solid #e9ecef; border-radius: 6px;
  margin-right: 8px; margin-bottom: 8px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  background: #f8f9fc;
  transition: transform 0.15s, box-shadow 0.15s;
}
.kyc-thumb:hover { transform: translateY(-2px); box-shadow: 0 2px 8px rgba(0,0,0,0.12); }
.kyc-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }
.kyc-thumb__lbl {
  position: absolute; bottom: 0; left: 0; right: 0;
  background: rgba(0,0,0,0.65); color: #fff;
  font-size: 11px; padding: 2px 6px; text-align: center;
}
.kyc-thumb__loading, .kyc-thumb__err {
  width: 100%; height: 100%;
  display: flex; align-items: center; justify-content: center;
  color: #adb5bd;
}
</style>
